<div class="evo-v2 shell" [class.sidebar-hidden]="sidebarState().isHidden">
  <app-v2-top-bar
    class="shell-topbar"
    [isSidebarHidden]="sidebarState().isHidden"
    (sidebarToggle)="toggleSidebar()"
    (accountToggle)="toggleAccount()" />

  <app-v2-rail
    class="shell-rail"
    [state]="sidebarState()"
    (stateChange)="onSidebarStateChange($event)" />

  <main class="shell-content">
    <!--
      Above the page rather than inside it: the trail is chrome, and a page
      that drew its own would have to know where it sits in the rail, which is
      the one thing a page should not have to know.
    -->
    <app-v2-breadcrumbs class="shell-crumbs" />
    <router-outlet />
  </main>

  <app-v2-tab-bar class="shell-tabbar" />

  <app-v2-account-panel [open]="accountOpen()" (close)="closeAccount()" />

  <app-toasts />
</div>
